module.exports = "https://static.energy5.com/_next/static/images/effortless2-2ed8c46397d1649862ffa5fa4ac7b9c9.png";